const ensureProtocol = (origin) => {
  if (!origin) return "";
  return /^https?:\/\//i.test(origin) ? origin : `http://${origin}`;
};

const normalizeOrigin = (origin) => origin.replace(/\/+$/, "");
const hasExplicitPort = (origin) => {
  try {
    return new URL(origin).port !== "";
  } catch (error) {
    return false;
  }
};

const devOrigin = normalizeOrigin(
  ensureProtocol(process.env.REACT_APP_CF_DEV || "localhost")
);
const prodOrigin = normalizeOrigin(
  ensureProtocol(process.env.REACT_APP_CF_PROD || "localhost")
);

export const CLOUD_FUNCTIONS_ORIGIN =
  process.env.NODE_ENV === "development"
    ? hasExplicitPort(devOrigin)
      ? devOrigin
      : `${devOrigin}:${process.env.REACT_APP_DEV_SERVER_PORT}`
    : prodOrigin;